import { ApolloClient, InMemoryCache } from '@apollo/client';
import { GRAPHQL_HTTP_ENDPOINT } from '../utils/constants';

const apollo = new ApolloClient({
  uri: GRAPHQL_HTTP_ENDPOINT,
  cache: new InMemoryCache()
});

export { apollo };
